import { useLocale } from "@lib/i18n/navigation-pages-router";

export function usePrice() {
  const locale = useLocale();

  return (amount, options = {}) => {
    const { withoutCents, withoutSpace } = options;

    const amntEuro = amount / 100;
    const amntIsInteger = Number.isInteger(amntEuro);
    const amntShortened =
      amntIsInteger && withoutCents ? Math.floor(amntEuro).toFixed(0) : amntEuro.toFixed(2);
    const finalAmount = amntShortened.replace(".", ",");

    if (!locale) return null;

    switch (locale) {
      case "nl":
      case "en":
        return `€${finalAmount}`;
      default:
        return `${finalAmount}${withoutSpace ? "" : "\u00A0"}€`;
    }
  };
}
